module.exports = __webpack_public_path__ + "img/price-click-5.a73de964.webp";